// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";

import type { ReportModalType } from "src/types";

type Props = {
  type: ReportModalType,
};

const Heading = ({ type }: Props) => {
  switch (type) {
    case "create":
    case "clone":
      return <>{i18n.t(k.SAVE_AS_REPORT)}</>;
    case "update":
      return <>{i18n.t(k.EDIT_REPORT_TITLE)}</>;
    case "delete":
      return <>{i18n.t(k.DELETE)}</>;
    default:
      return <></>;
  }
};

export default Heading;
